"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasAccounts = void 0;
const sdk_1 = require("../sdk");
const models_1 = require("@lantern/models");
var CanvasAccounts;
(function (CanvasAccounts) {
    CanvasAccounts.RegistrationAccessMode = models_1.CanvasAccount.RegistrationAccessMode;
    CanvasAccounts.list = (options) => {
        const url = '/canvas-accounts';
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    CanvasAccounts.create = (data) => {
        const url = '/canvas-accounts';
        return sdk_1.SDK.axios.post(url, data);
    };
    CanvasAccounts.get = (canvasAccountId) => {
        const url = `/canvas-accounts/${canvasAccountId}`;
        return sdk_1.SDK.axios.get(url);
    };
    CanvasAccounts.update = (canvasAccountId, data) => {
        const url = `/canvas-accounts/${canvasAccountId}`;
        return sdk_1.SDK.axios.put(url, data);
    };
    CanvasAccounts.remove = (canvasAccountId) => {
        const url = `/canvas-accounts/${canvasAccountId}`;
        return sdk_1.SDK.axios.delete(url);
    };
})(CanvasAccounts = exports.CanvasAccounts || (exports.CanvasAccounts = {}));
//# sourceMappingURL=canvas-accounts.js.map